import React, { useState } from 'react';

import { Avatar, Box, Typography } from '@mui/material';

import dayjs from 'dayjs';

import { ConversationItem } from '../../../graphql/API';

type Props = {
  active?: boolean;
  onConversation: () => void;
} & ConversationItem;

export const Thread: React.FC<Props> = ({
  active = false,
  firstname,
  lastname,
  fromUserMessageCount,
  images,
  messageTime,
  onConversation,
  offerTitle,
}) => {
  const [clicked, setClicked] = useState(false);

  const hasUnreadMessages = !clicked && fromUserMessageCount && fromUserMessageCount > 0;

  const handleClick = () => {
    setClicked(true);
    onConversation();
  };

  return (
    <Box
      sx={{
        borderRadius: '10px',
        backgroundColor: active ? '#F2EFFA' : '',
        border: active ? '1px solid #E4DEF7' : '1px solid transparent',
        paddingY: '16px',
        paddingX: '16px',
        marginX: '12px',
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer',
        marginBottom: '6px',
        position: 'relative',
        transition: 'background-color 0.15s ease, border-color 0.15s ease',
        '&:hover': {
          backgroundColor: active ? '#F2EFFA' : '#F8F9FB',
        },
      }}
      onClick={handleClick}
    >
      {hasUnreadMessages ? (
        <Box
          sx={{
            position: 'absolute',
            left: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#FF0126',
          }}
        />
      ) : null}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <Avatar src={images?.thumbnail || ''} alt={firstname || 'user-picture'} />
        <Box>
          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: active ? 500 : 300,
              fontFamily: 'Poppins',
              color: active ? '#765BC6' : 'inherit',
            }}
          >
            {firstname} {lastname}
          </Typography>
          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 300,
              color: '#949BA5',
              mt: '3px',
              fontFamily: 'Poppins',
            }}
          >
            {offerTitle}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-end' }}>
        {fromUserMessageCount && fromUserMessageCount > 0 ? (
          <Typography
            sx={{ fontSize: '13px', fontWeight: 500, color: '#FF0126', fontFamily: 'Poppins' }}
          >
            {fromUserMessageCount} {fromUserMessageCount > 1 ? `Messages` : 'Message'}
          </Typography>
        ) : null}
        <Typography
          sx={{ fontSize: '13px', fontWeight: 400, color: '#949BA5', fontFamily: 'Poppins' }}
        >
          {messageTime ? dayjs(messageTime).format('LT') : null}
        </Typography>
      </Box>
    </Box>
  );
};
